export default "/assets/images/column-image3.01d4a482103e7e72.png";